module.exports = __webpack_public_path__ + "static/media/runner.b95103b8.svg";